import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAPersonalFamilyCare() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ personalFamilyCare, setPersonalFamilyCare ] = useState(powerOfAttorney.personal_family_care || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../legal-actions');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      personal_family_care: personalFamilyCare
    }));
    navigate('../pet-care');
  }, [ personalFamilyCare, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-personal-family-care screen-container screen">
      <ScreenHeader
        title="Personal & Family Care"
        description="Decide whether to grant your agent power over personal and family matters"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Personal & Family Care Powers?</h3>
        <p>
          Personal and family care powers allow your agent to handle personal matters 
          and support your family members. This includes:
        </p>
        <ul className="personal-care-list">
          <li>Caring for dependents and family members</li>
          <li>Managing household expenses and maintenance</li>
          <li>Hiring caregivers and household help</li>
          <li>Making arrangements for personal care</li>
          <li>Supporting spouse, children, and dependents</li>
          <li>Managing personal living arrangements</li>
          <li>Handling personal relationships and communications</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Provide financial support to family members</li>
          <li>Hire personal care services</li>
          <li>Make arrangements for your personal needs</li>
          <li>Manage household operations</li>
          <li>Handle family emergencies</li>
          <li>Coordinate with healthcare providers</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="personal-family-care-yes"
            label="Yes"
            description="Grant power over personal and family care"
            value="yes"
          />
          <AssetDistributionOption
            id="personal-family-care-no"
            label="No"
            description="Do not grant power over personal and family care"
            value="no"
          />
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            This power is separate from healthcare decisions and does not include medical 
            decision-making authority. It focuses on financial support and arrangements 
            for personal and family care.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
